import { configureStore } from '@reduxjs/toolkit';
import CustomerDetailsReducer from './customerDetailsInfo';
import AppConfigReducer from './appConfigInfo';
import DirectoryReducer from './directory';

export default configureStore({
  reducer: {
    customerDetailsInfo: CustomerDetailsReducer,
    appConfigInfo: AppConfigReducer,
    directory: DirectoryReducer,
  },
})